import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { CardActionArea } from "gatsby-theme-material-ui";
import { Link } from "gatsby";

export default function BelowSlider({ data }) {
  const { allMarkdownRemark } = data;

  return (
    <>
      {allMarkdownRemark.nodes.map((i) => (
        <Link key={i.slug} to={i.slug} style={{ textDecoration: "none" }}>
          <Card sx={{ mt: 1 }}>
            <CardActionArea sx={{ display: "flex" }}>
              <CardMedia sx={{ position: "relative" }}>
                <Box
                  component={GatsbyImage}
                  image={getImage(i.frontmatter.featuredImage)}
                  sx={{ width: { xs: 136, sm: 284 } }}
                />
                <Chip
                  label={i.frontmatter.category.toUpperCase()}
                  color="primary"
                  size="small"
                  sx={{ position: "absolute", top: 0, left: 0, m: 1 }}
                />
              </CardMedia>
              <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
                <Typography fontWeight="bold" gutterBottom>
                  {i.frontmatter.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  {i.excerpt}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Link>
      ))}
    </>
  );
}

export const query = graphql`
  query ($category: String!) {
    allMarkdownRemark(
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { category: { eq: $category } } }
      limit: 22
    ) {
      nodes {
        slug: gatsbyPath(
          filePath: "/{MarkdownRemark.frontmatter__category}/{MarkdownRemark.frontmatter__title}"
        )
        excerpt(pruneLength: 170)
        frontmatter {
          category
          title
          author
          featuredImage {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: FULL_WIDTH
                transformOptions: {
                  duotone: {
                    shadow: "#222222"
                    highlight: "#222222"
                    opacity: 40
                  }
                }
              )
            }
          }
          date(formatString: "DD MMMM YYYY", locale: "mk-MK")
        }
      }
    }
  }
`;
